import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#FFF8E7] text-[#3E2723] border-t border-[#E8DFD0]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="mb-4">
              <img
                src="https://static.readdy.ai/image/348a7e79db923e10de5eaa6a9ed811e1/007867941abd742092042ade6d55ebca.png"
                alt="El Bocado Empanadas Argentinas"
                className="w-36 h-36 object-contain"
              />
            </div>
            <p className="text-[#5D5D5D] text-sm leading-relaxed mb-6">
              Empanadas argentinas artesanales en Blanes. Tradición, calidad y sabor auténtico en cada bocado.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/elbocadoblanes/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#3E2723]/10 hover:bg-[#3E2723]/20 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl text-[#3E2723]"></i>
              </a>
              <a
                href="https://www.facebook.com/elbocadoblanes"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#3E2723]/10 hover:bg-[#3E2723]/20 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl text-[#3E2723]"></i>
              </a>
              <a
                href="https://wa.me/34694410302"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#3E2723]/10 hover:bg-[#3E2723]/20 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl text-[#3E2723]"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-[#3E2723]">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-[#5D5D5D] hover:text-[#3E2723] hover:underline transition-all duration-300 cursor-pointer"
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/historia"
                  className="text-[#5D5D5D] hover:text-[#3E2723] hover:underline transition-all duration-300 cursor-pointer"
                >
                  Nuestra Historia
                </Link>
              </li>
              <li>
                <Link
                  to="/menu"
                  className="text-[#5D5D5D] hover:text-[#3E2723] hover:underline transition-all duration-300 cursor-pointer"
                >
                  Carta
                </Link>
              </li>
              <li>
                <Link
                  to="/catering"
                  className="text-[#5D5D5D] hover:text-[#3E2723] hover:underline transition-all duration-300 cursor-pointer"
                >
                  Catering
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-[#5D5D5D] hover:text-[#3E2723] hover:underline transition-all duration-300 cursor-pointer"
                >
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-[#3E2723]">Contacto</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-[#8B5A3C]"></i>
                </div>
                <div>
                  <p className="text-[#5D5D5D] text-sm">
                    Carrer de Tapioles<br />
                    17300 Blanes, Girona
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-xl text-[#8B5A3C]"></i>
                </div>
                <div>
                  <p className="text-[#5D5D5D] text-sm">694 41 03 02</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-time-line text-xl text-[#8B5A3C]"></i>
                </div>
                <div>
                  <p className="text-[#5D5D5D] text-sm">
                    Jue - Mar: 10:30 - 14:00<br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;17:30 - 21:30<br />
                    Miércoles: Cerrado
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#3E2723]/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#5D5D5D] text-sm">
              © {new Date().getFullYear()} El Bocado. Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <Link to="/privacidad" className="text-[#5D5D5D] text-sm hover:text-[#3E2723] transition-colors duration-300 cursor-pointer">
                Privacidad
              </Link>
              <Link to="/terminos" className="text-[#5D5D5D] text-sm hover:text-[#3E2723] transition-colors duration-300 cursor-pointer">
                Términos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}